import React from "react";

import styles from "../../../styles/integrations.module.scss";

import { IntegrationsAPI } from "../../../providers/IntegrationsAPI";
import { EnvironmentStorage } from "../../tools/EnvironmentStorage";
import { Loading } from "../../components/Loading";
import { Drawer } from "../../components/Drawer";
import { Input } from "../../components/Input";
import { Button } from "../../components/Button";
import { Checkbox } from "../../components/Checkbox";
import { Context } from "pages/Integrations";
import { Toggle } from "shared/components/Toggle";
import { Message, Select } from "@components";

export default class BeeDeliveryDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadingPage: true,
      loading: false,
      environmentId: EnvironmentStorage.getEnvironment()?.id,
      environment: "PRODUCTION",
      active: true,
      merchantId: "",
      cancelationControl: true,
      allowPreview: true,
      allowManualDispatch: false,
    };
  }

  componentDidMount() {
    this.loadAccount();
  }

  async loadAccount() {
    const { environmentId } = this.state;

    const accountResponse = await IntegrationsAPI.getBeeDeliveryAccount(
      environmentId
    );
    const account = accountResponse.getData({});

    this.setState({
      environment: account?.environment,
      externalId: account?.externalId,
      document: account?.document,
      active: account?.active,
      cancelationControl: account?.cancelationControl || false,
      allowPreview: account?.allowPreview || false,
      allowManualDispatch: account?.allowManualDispatch || false,
      loadingPage: false,
    });
  }

  async updateAccount(configs) {
    const { environmentId } = this.state;

    this.setState({
      loading: true,
    });

    const updateResponse = await IntegrationsAPI.upsertBeeDeliveryAccount(environmentId, configs);

    if (updateResponse.getErrors([]).length > 0) {
      alert({ text: updateResponse.getErrors()[0], buttonText: "Ok" });
      this.setState({
        loading: false,
      });
      return false;
    }

    this.setState({
      loading: false,
    });

    return true;
  }

  async changeStep(newStep) {
    this.setState({
      step: newStep,
    });
  }

  render() {
    const {
      loading,
      loadingPage,
      environmentId,
      active,
      document,
      cancelationControl,
      allowPreview,
      allowManualDispatch,
    } = this.state;
    
    const { visible, onClose } = this.props;

    const isValid = document?.type && document?.value?.length >= 11;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Bee Delivery"
      >
        <Context />

        {loadingPage && (
          <div className={styles.loading}>
            <Loading />
          </div>
        )}
        {!loadingPage && (
          <div className={styles.scrollContainer}>
            <div className={styles.toggle}>
              <div className="d-flex justify-end w-100">
                <Toggle
                  active={active}
                  onChange={(active) => this.setState({ active })}
                />
              </div>
            </div>

            <Input
              design="two"
              label="ID externo"
              className="mb-20"
              value={environmentId}
              disabled={true}
            />

            <Select
              design="two"
              label="Tipo do documento"
              onChange={(e) =>
                this.setState({
                  document: {
                    ...(document || {}),
                    type: e.target.value,
                  },
                })
              }
              className="mb-20"
              value={document?.type || ""}
              options={[
                {
                  label: "",
                  value: "",
                  selected: false,
                },
                {
                  label: "CPF",
                  value: "F",
                  selected: document?.type === "F",
                },
                {
                  label: "CNPJ",
                  value: "J",
                  selected: document?.type === "J",
                },
              ]}
            />

            <Input
              design="two"
              label="Documento"
              className="mb-20"
              value={document?.value || ""}
              onChange={(e) =>
                this.setState({
                  document: {
                    ...(document || {}),
                    value: String(e.target.value || '').replace(/\D/g, ""),
                  },
                })
              }
            />

            <Checkbox
              name="cancelationControl"
              design="two"
              className="mb-10"
              checked={cancelationControl}
              onChange={() =>
                this.setState({
                  cancelationControl: !cancelationControl,
                })
              }
            >
              Cancelar pedido quando o operador logístico cancelar ou não
              conseguir efetuar a entrega?{" "}
            </Checkbox>

            <Checkbox
              name="allowPreview"
              design="two"
              className="mb-10"
              checked={allowPreview}
              onChange={() =>
                this.setState({
                  allowPreview: !allowPreview,
                })
              }
            >
              Utilizar valor do frete da Bee Delivery?{" "}
            </Checkbox>

            <Checkbox
              name="allowManualDispatch"
              design="two"
              checked={allowManualDispatch}
              onChange={() =>
                this.setState({
                  allowManualDispatch: !allowManualDispatch,
                })
              }
            >
              Chamar entregador manualmente?{" "}
            </Checkbox>

            <Message className="mt-20">
              <p>
                Para utilizar a integração é necessário possuir cadastro na Bee Delivery. Caso ainda não fez o cadastro, acesse o link abaixo:
              </p>
              <br />
              <a href="https://www.beedelivery.com.br/empresas" target="_blank" >https://www.beedelivery.com.br/empresas</a>
            </Message>

            <div className={styles.footer}>
              <Button
                design="primary"
                className="w-100"
                onClick={() =>
                  this.updateAccount({
                    active: active,
                    externalId: environmentId,
                    document: document,
                    cancelationControl: cancelationControl,
                    allowPreview: allowPreview,
                    allowManualDispatch: allowManualDispatch,
                  })
                }
                loading={loading}
                disabled={loading || !isValid}
              >
                Salvar
              </Button>
            </div>
          </div>
        )}
      </Drawer>
    );
  }
}
